import { Component, Inject } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NGXLogger } from "ngx-logger";
import { UserSettingsService } from "../../services/user-settings-service";
import { LoginComponent } from "./login.component";

@Component({
    selector: 'login-b',
    providers: [],
    templateUrl: './login-b.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponentB extends LoginComponent {
    public constructor(
        @Inject(NgbActiveModal) activeModal: NgbActiveModal,
        @Inject(NGXLogger) logger: NGXLogger,
        @Inject(UserSettingsService) userSettingsSrvs: UserSettingsService
    ) {
        super(activeModal, logger, userSettingsSrvs); 
        this.rememberMe = true;
    }
}

